export default "__VITE_ASSET__Cwrf2YiG__"